export const handleSidebar = () => {
	const wrapperDiv = window.$("#wrapperDiv");
	wrapperDiv.toggleClass("toggled");
};
